import ListItem from '../../../../components/ListItem';
import './SelectNetwork.scss';

const SelectNetworkBody = ({ handleClose, outsideParams }) => {
	const { networkManual, setNetwork } = outsideParams;

	return (
		<div className='SelectNetworkBody'>
			<div className='FormBlock'>
				{networkManual.blockchains.map(i => (
					<ListItem
						key={i.Label}
						onSelect={() => {
							setNetwork(i);
							handleClose();
						}}
						icon={i.symbol}
						title={i.Label}
					/>
				))}
			</div>
		</div>
	);
};

export default SelectNetworkBody;
